module.exports = {
 url: '/services/:slug:service',
 template: require('raw!templates/services/services.html'),
 controller: ServicesController,
 controllerAs: 'servicesCtrl',
 params: {
   service: {
       value: '',
       squash: true
     },
   slug: {
       value: '',
       squash: true
     }
 }
}

function ServicesController ($scope, $state, store, contentful,  $uibModal, $window) {
  	$window.scrollTo(0, 0);
    var vm = this;

    if(store.get('selectedService')) {
      $scope.selectedService = store.get('selectedService')
    } else {
      $scope.selectedService = store.get('defaultService')
    }
    $scope.setSelectedService = function (serviceProvided) {
      if(serviceProvided){
        store.set('selectedService', serviceProvided)
      } else {
        store.set('selectedService', $scope.defaultService)
      }
    }
    function comparePriority(a,b) {
    if (a.fields.priority < b.fields.priority)
      return -1;
    if (a.fields.priority > b.fields.priority)
      return 1;
    return 0;
    }
    $scope.allServices = []
    contentful.entries('content_type=serviceTypes').then(function(res) {
      var items = res.data.items
      angular.forEach(items, function(item){
        $scope.allServices.push(item)
      })
      $scope.defaultService = $scope.allServices[0]
      store.set('defaultService', $scope.defaultService)
     })
    $scope.selectService = function (service) {
      $scope.currentService = service
      $scope.page = $scope.currentService.fields.pageTitle
    }
  vm.slugify = function(string) {
    return Slug.slugify(string);
  };

  if ($state.params.obj) {
    $scope.selectedService = $state.params.obj
    store.set('selectedService', $state.params.obj)
  } else if ($state.params.slug) {
    contentful.entries('content_type=serviceTypes&fields.pageTitle=' + $state.params.slug).then(function(res) {
         $scope.selectedService = res.data.items[0];
       })
  } else if (store.get('selectedService')) {
    $scope.selectedService = store.get('selectedService');
  }

  if($state.params.service) {
    $scope.page = $state.params.service
    $scope.currentServiceProvided = $state.params.service
    $scope.selectedService = $state.params.service.fields.pageTitle
    $scope.serviceDesc = $state.params.service.fields.pageSpecificMetaDescriptionSeo
    store.set('services', $scope.selectedService);
  } else if(store.get('selectedServices')){
    $scope.currentServiceProvided = store.get('selectedServices')
    $scope.selectedService = $scope.currentServiceProvided.fields.pageTitle
    $scope.serviceDesc = $scope.currentServiceProvided.fields.pageSpecificMetaDescriptionSeo
  }
   $scope.allServicesProvided = []
   $scope.slide = {
     'serviceNav': true
   }

  if($state.params.service) {
    $scope.currentService = $state.params.service
    $scope.page = $scope.currentService.fields.pageTitle
    $scope.email = $scope.currentService.fields.contactPerson
  } else if (store.get('selectedService')){
    $scope.currentService = store.get('selectedService')
    $scope.page = $scope.currentService.fields.pageTitle
    $scope.email = $scope.currentService.fields.contactPerson
    $scope.selectedService = $scope.currentService.fields.pageTitle
    $scope.serviceDesc = $scope.currentService.fields.pageSpecificMetaDescriptionSeo
    // console.log('data', $scope.currentService.fields.pageTitleSeo )
    document.title = $scope.currentService.fields.pageTitleSeo
    if ($scope.currentService.fields.pageSpecificMetaDescriptionSeo) {
       var meta = document.getElementsByTagName("meta");
       for (var i = 0; i < meta.length; i++) {
         if (meta[i].name.toLowerCase() === "description") {
           meta[i].content = $scope.serviceDesc ;
         }
       }
     }
  }
  $window.scrollTo(0,0);
}



/** WEBPACK FOOTER **
 ** ./components/templates/services/services.js
 **/